export const SYNTHETIC_EMAIL_DOMAIN = "accounts.garimpa.invalid";

export function isSyntheticEmail(email: string): boolean {
  return email.toLowerCase().endsWith(`@${SYNTHETIC_EMAIL_DOMAIN}`);
}
